import React, { useState, useEffect, useContext } from 'react'
import moment from 'moment'
import useResErrors from 'hooks/useResErrors'
import jwtDecode from 'jwt-decode'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from 'store/rootStore'
import { getSupportList, getSupportById } from 'requests/misc'
import { Grid, LinearProgress } from '@material-ui/core'
import { negativeC } from 'asterX-UIkit/constants/colors'
import DataTableWithPagination from 'asterX-UIkit/Table/DataTableWithPagination'
import CreateModal from './modals/CreateModal'
import { Filter } from './Filter'
import * as status from 'constants/statuses'
import * as division from 'constants/divisions'

const UserPanel = ({ selectedTab, statusList }) => {
  const { authStore } = useContext(RootStoreContext)
  const { standardCheck } = useResErrors()
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const [page, setPage] = useState(1)
  const [selectedData, setSelectedData] = useState({})
  const [isOpen, setIsOpen] = useState(false)
  const [totalElements, setTotalElements] = useState(0)
  const [filter, setFilter] = useState({})

  const columns = [
    { id: 'id', label: 'Номер заявки' },
    {
      id:
        authStore.statusRequest.includes(status.NEW_STATUS) ||
        !authStore.statusRequest.length
          ? 'createdDate'
          : authStore.statusRequest.some(f =>
              [
                status.IN_PROGRESS_STATUS,
                status.NEED_REVISION_STATUS,
                status.POSTPONED_STATUS
              ].includes(f)
            )
          ? 'inProcessDate'
          : 'completedDate',
      label:
        authStore.statusRequest.includes(status.NEW_STATUS) ||
        !authStore.statusRequest.length
          ? 'Дата создания'
          : authStore.statusRequest.some(f =>
              [
                status.IN_PROGRESS_STATUS,
                status.NEED_REVISION_STATUS,
                status.POSTPONED_STATUS
              ].includes(f)
            )
          ? 'Дата приема'
          : 'Дата завершения',
      format: value => moment(value).format('DD.MM.YYYY HH:mm:ss')
    },
    { id: 'status', label: 'Статус' },
    authStore.division === division.ASTERX_DIVISION && {
      id: 'type',
      label: 'Тип'
    },
    authStore.division === division.ASTERX_DIVISION && {
      id: 'serviceName',
      label: 'Услуга'
    },
    authStore.division === division.HELP_DESK_DIVISION && {
      id: 'module',
      label: 'Модуль'
    },
    {
      id: 'department',
      label: 'Ответственный'
    },
    { id: 'copyAction', label: '' },
    {
      id: 'unAnswered',
      label: 'Уведомление',
      format: value => (
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: '50%',
            background: value ? negativeC : 'transparent'
          }}
        />
      )
    }
  ]

  const onReset = () => {
    setFilter({})
  }

  const onSearch = () => {
    const token = localStorage.getItem('token')
    const currentUser = jwtDecode(token)
    setLoading(true)

    getSupportList({
      ...filter,
      status: statusList
        .filter(e =>
          selectedTab === 1
            ? [1, 2, 3, 4].includes(e.id)
            : [5, 6].includes(e.id)
        )
        .map(e => e.request[0]),
      createdBy: currentUser.sub,
      offset: (page - 1) * 10,
      limit: 10
    }).then(res =>
      standardCheck(
        res,
        () => {
          setLoading(false)
          setTotalElements(res.countFiltered)
          setList(
            res.listFiltered.map(item => {
              if (item.chat) {
                const chat = JSON.parse(item.chat)
                const lastMessage = chat[chat.length - 1]
                return {
                  ...item,
                  unAnswered: lastMessage.author !== currentUser.sub
                }
              }
              return { ...item, unAnswered: false }
            })
          )
        },
        ' загрузки панели ',
        () => {
          setLoading(false)
        }
      )
    )
  }

  const handleCopy = async (id = null) => {
    if (!isNaN(id)) {
      await getSupportById(id).then(res => {
        setSelectedData({
          ...res,
          id: null,
          adminFullname: null,
          adminUsername: null,
          createdBy: null,
          createdByFullname: null,
          createdDate: null,
          inProcessDate: null,
          completedDate: null,
          reason: null,
          comment: null,
          status: null
        })
      })
    }
    setIsOpen(true)
  }

  const handleOpen = async (id = null) => {
    if (!isNaN(id)) {
      await getSupportById(id).then(res => {
        setSelectedData(res)
      })
    }
    setIsOpen(true)
  }

  useEffect(() => {
    onSearch()
  }, [isOpen, page, authStore.division, authStore.statusRequest])

  useEffect(() => {
    if (!Object.keys(filter).length) {
      onSearch()
    }
  }, [filter])

  return (
    <Grid
      container
      direction={'row'}
      justify={'flex-start'}
      alignItems={'center'}
      spacing={2}
      style={{ paddingBottom: 64 }}
    >
      {loading && (
        <Grid item xs={12} md={12}>
          <LinearProgress />
        </Grid>
      )}
      <Grid item xs={12} ma={12}>
        <Filter
          loading={loading}
          filter={{ filter, setFilter }}
          onSearch={onSearch}
          onReset={onReset}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <DataTableWithPagination
          page={{ page, setPage }}
          columns={columns}
          editAction={handleOpen}
          copyAction={handleCopy}
          totalElements={totalElements}
          rows={list}
        />
      </Grid>
      {isOpen && (
        <CreateModal
          open={isOpen}
          prevForm={selectedData}
          onClose={() => {
            setSelectedData({})
            setIsOpen(false)
          }}
        />
      )}
    </Grid>
  )
}

export default observer(UserPanel)
